import styled from 'styled-components';

import AlertBox from 'components/ui/AlertBox';
import { ConfirmButton } from 'components/ui/Button';

import { colours } from 'themes/default';
import { BREAKPOINTS } from 'constants/breakpoints';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const StyledAlertBox = styled(AlertBox)`
  border-radius: 0;
  margin-bottom: 5px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    min-width: 100%;
    min-width: max-content;
  }
`;

export const Reference = styled.span`
  font-weight: bold;
`;

export const CenterAlign = styled.span`
  display: flex;
  justify-content: center;
`;

export const StyledConfirmButton = styled(ConfirmButton)`
  white-space: nowrap;
`;

export const ExternalReferencesNumber = styled.span`
  cursor: pointer;
  font-weight: bold;
  color: ${colours.Shades.TintBlue40};
`;
